
import { Options } from "vue-class-component";
import NodesMinxins from "../NodesMixins";

@Options({
    name: "flowable-nodes-empty-node",
    emits: ["insertNode"],
})
export default class EmptyNode extends NodesMinxins {}
